const NoteFormResources = {

    form_data:{
        title: '',
        associate_id: [],
        date_method: '',
        numeric_time_drop:  1,
        body_text: '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  50,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'vue-multiselect',
            multiple:   true,
            show_number_items_selected: true,
            items_selected_message: 'Associates selected',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Display to:',
            empty_option_name:  'My whole team',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Auto-delete after:',
            empty_option_name:  'None',
            model_name: 'date_method',
            ref:        'date_method_input',
            ref_alt:    'date_method_input_alt',
            required:   false,
        },
    ],

    form_format_lite:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  50,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'vue-multiselect',
            multiple:   true,
            show_number_items_selected: true,
            items_selected_message: 'Associates selected',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Display to:',
            empty_option_name:  'My whole team',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Auto-delete after:',
            empty_option_name:  'None',
            model_name: 'date_method',
            ref:        'date_method_input',
            ref_alt:    'date_method_input_alt',
            required:   false,
        },
    ],


    form_format_3:[
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  150,
            disabled:   false,
            step:       '',
            name:       'Content:',
            model_name: 'body_text',
            ref:        'body_text_input',
            ref_alt:    'body_text_input_alt',
            required:   true,
        },
    ],
}

export default NoteFormResources;